import React from "react";
import HomeC from "features/home";
function Home() {
  return <HomeC />;
}

export default Home;
